/** zh-CN catalogue `effectsDev` (W3-09; English: src/render/preview/effects/dev/effectsDev.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const catalog: MessageCatalog = {
  ns: 'effectsDev',
  locale: 'zh-CN',
  messages: {
    title: '特效对照器',
    intro:
      '将 extra.json 特效的预览与 Phira 对照。下载截图套件，在 Phira 中播放，在 0:16 之前（特效关闭）和之后（特效开启）各截一张图，然后在这里加载这两张截图。',
    alpha: 'Alpha',
    before: '之前（特效关闭）',
    beforeHint: '特效读取的画面。在你加载截图之前使用测试卡。',
    blinkShowing: '显示：{name}',
    chooseImage: '选择图片',
    copied: '已复制',
    copy: '复制',
    differs: '与 Phira 不同',
    downloadJson: '下载 JSON',
    downloadKit: '下载截图套件（.pez）',
    dropHint: '或将图片拖放到此处',
    droppedVars: '因数值不符合 uniform 类型而被忽略：{names}',
    effect: '特效',
    entryIncomplete: 'SIGNED_OFF 条目需要 Phira 截图、测试者和 Phira 版本。缺少：{missing}。',
    entryNeedCapture: 'Phira 截图',
    entryNeedPhiraVersion: 'Phira 版本',
    entryNeedTester: '测试者',
    fidelity: '预览状态：{status}',
    identical: '完全相同',
    imageFailed: '无法将此文件读取为图片。',
    imageSize: '{name}，{w} x {h}',
    images: '截图',
    kit: '截图套件',
    kitHint:
      '一个包含测试卡以及此特效（使用这些数值）的 Phira 谱面包。特效在 0:16 之前关闭，在 0:16 到 0:40 之间开启。',
    kitName: 'Phiedit 特效检查：{effect}',
    kitTip: '在 0:16 之前（特效关闭）和 0:16 之后（特效开启）各截一张图。',
    levelValue: '{value, number, 0.0} / 255',
    matches: '与 Phira 一致',
    noCapture: '加载一张 Phira 截图以进行对照。',
    noWebgl: '此浏览器不支持 WebGL 2，因此无法在此绘制特效。',
    notPreviewed: '预览中没有此特效的着色器。',
    notes: '备注',
    paneDiff: '差异',
    paneOurs: 'Phiedit',
    panePhira: 'Phira',
    percentValue: '{value, number, 0.00}%',
    phira: 'Phira（特效开启）',
    phiraHint: '特效开启时的 Phira，窗口大小与“之前”相同。',
    phiraVersion: 'Phira 版本和设备',
    probe: 'UV 方向探测（自定义着色器）',
    probeAmount: '染色程度',
    probeDesc:
      '向右将画面染成红色，向上染成绿色。如果 Phira 像预览一样把 uv (0, 0) 放在左下角，左上角会变绿，右下角会变红，而左下角不会染上红色或绿色（只会变暗）。',
    psnrValue: '{value, number, 0.0} dB',
    record: '记录结果',
    recordHint:
      '将记录和两张截图保存在 docs/verification/effects/ 中。要签核一个一致的内置特效，请将下方的条目添加到 src/render/preview/effects/builtin/signOff.ts 的 SIGNED_OFF 中——但只能在 CR-2（effectBadges 的“verified”分支）落地之后：届时它的“近似”标记会消失。在 CR-2 落地之前，已签核的内置特效会显示“特效未预览”。',
    removeImage: '移除',
    resetValues: '恢复默认值',
    saveRender: '保存 Phiedit 渲染图（.png）',
    scope: '作用范围',
    scopeChart: '谱面区域，16:9（非全局）',
    scopeGlobal: '整个屏幕（全局）',
    shaderError: '着色器编译失败：{log}',
    signOffEntry: 'SIGNED_OFF 条目',
    sizeMismatch: 'Phira 截图为 {w} x {h}，而“之前”为 {bw} x {bh}，因此已缩放后对照。请以相同的窗口大小截取两张截图。',
    statMax: '最大差异',
    statMean: '平均差异',
    statOver: '偏差超过 {threshold} 的像素',
    statPsnr: 'PSNR',
    stats: '差异',
    testCard: '测试卡',
    tester: '测试者',
    time: '时间（秒）',
    timeHint: '作为时间传给着色器的谱面秒数。只有“故障”和自定义着色器使用它。',
    useTestCard: '使用测试卡',
    values: '数值',
    view: '视图',
    viewBlink: '闪烁对比',
    viewDiff: '差异',
    viewSide: '并排',
    glitchTimeHint:
      '“故障”特效每秒会多次改变其条带（每秒变化次数），因此只有在 Phira 截图对应的谱面时间才会与 Phira 一致。要逐像素对照，请在此输入该时间：Phira 截图顶部进度条的填充比例乘以 {song} 秒（套件中曲目的长度）。否则请用肉眼对照“故障”特效：条带高度、错位和颜色分离。',
    scopeChartHud:
      'Phira 会在谱面区域特效之后绘制其 HUD（分数、进度条、暂停按钮），因此那里的特效永远不会影响 HUD。这里的特效也会作用于“之前”截图中的 HUD，因此 HUD 总会显示为不同。如需干净的对照，请使用“整个屏幕”。',
  },
};

export default catalog;
